import React from 'react';
import styled from 'styled-components';

import cancelIcon from '~images/Ruksi_ikoni_valkoinen.svg';

const FollowedUnit = ({ unit, removeFollowedOrganization }) => (
  <Wrapper>
    <Unit>{unit.name || 'Tuntematon yksikkö'}</Unit>
    <CancelIcon
      alt="Poista seurattava yksikkö"
      src={cancelIcon}
      onClick={() => removeFollowedOrganization(unit.id)}
    />
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CancelIcon = styled.img`
  width: 11px;
  margin-right: -23px;
  margin-left: 8px;
  cursor: pointer;
`;

const Unit = styled.div`
  height: 40px;
  border: 1px solid white;
  border-radius: 3px;
  display: flex;
  align-items: center;
  color: white;
  width: 100%;
  padding: 10px 20px;
  font-size: 16px;
  cursor: default;
`;

export default FollowedUnit;
